import { render } from "./MedicalPage.vue?vue&type=template&id=aeb871a4"
import script from "./MedicalPage.vue?vue&type=script&lang=js"
export * from "./MedicalPage.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__